import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2, Shield } from 'lucide-react';

export default function CaseStudyModal({ isOpen, data, onClose }) {
  if (!data) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-[#0A1931]/40 backdrop-blur-sm"
          />

          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="relative w-full max-w-4xl bg-white rounded-[1.5rem] shadow-2xl overflow-hidden flex flex-col md:flex-row"
          >
            {/* Close Button - Plus discret */}
            <button 
              onClick={onClose}
              className="absolute top-4 right-4 z-10 p-2 bg-white/80 hover:bg-[#3b82f6] hover:text-white rounded-full transition-all"
            >
              <X size={18} />
            </button>

            {/* Section Visuelle Gauche - Largeur réduite */}
            <div className="w-full md:w-[35%] bg-[#0A1931] relative">
              <img 
                src={data.image} 
                alt={data.title} 
                className="w-full h-full object-cover opacity-60"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A1931] via-[#0A1931]/20 to-transparent" />
              <div className="absolute bottom-6 left-6 text-white">
                <p className="text-[8px] font-black uppercase tracking-[0.2em] text-[#3b82f6] mb-1">{data.category}</p>
                <h2 className="text-xl font-black leading-tight">{data.title}</h2>
              </div>
            </div>

            {/* Section Contenu Droite - Optimisée pour l'espace */}
            <div className="w-full md:w-[65%] p-6 md:p-8 bg-white">
              <div className="space-y-6">
                
                {/* Mission Condensée */}
                <section>
                  <h4 className="text-[#0A1931] text-[9px] font-black uppercase tracking-widest mb-2 opacity-40">Investigation</h4>
                  <p className="text-slate-600 text-[13px] leading-relaxed font-medium">
                    {data.fullDetail}
                  </p>
                </section>

                {/* Résultats en Grille (2 colonnes sur desktop pour gagner de la hauteur) */}
                <section>
                  <h4 className="text-[#0A1931] text-[9px] font-black uppercase tracking-widest mb-3 opacity-40">Impact Opérationnel</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    {data.results.map((res, i) => (
                      <div key={i} className="flex items-center gap-2 bg-[#F6FAFD] p-2.5 rounded-lg border border-blue-50">
                        <CheckCircle2 className="text-[#3b82f6] shrink-0" size={14} />
                        <span className="text-[#0A1931] text-[11px] font-bold leading-tight">{res}</span>
                      </div>
                    ))}
                  </div>
                </section>

                {/* Tags & Action sur la même ligne */}
                <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-4 border-t border-slate-50">
                  <div className="flex flex-wrap gap-1.5">
                    {data.tags.slice(0, 3).map((tag, i) => (
                      <span key={i} className="px-2 py-1 bg-slate-50 text-slate-400 text-[8px] font-black rounded uppercase border border-slate-100">
                        {tag}
                      </span>
                    ))}
                  </div>
                  
                  <button className="w-full md:w-auto px-6 py-2.5 bg-[#3b82f6] text-white rounded-lg font-black text-[10px] uppercase tracking-widest hover:bg-[#0A1931] transition-all shadow-md shadow-blue-100">
                    Contacter l'expert
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}